export const SILENT_ERROR_PREFIX = '[silent-app-error]: ' as const;

const escapeRegExp = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\-]/g, '\\$&');

export const SILENT_ERROR_MESSAGE_PATTERN = new RegExp(
  `^${escapeRegExp(SILENT_ERROR_PREFIX)}`
);

export const createSilentError = (detail: string): Error =>
  new Error(`${SILENT_ERROR_PREFIX}${detail}`);
